import { useEffect, useState } from "react";
import AuthenticationService from "../services/AuthenticationService";
import apiRequest from "@services/apiRequest";
import Modal from "../ui-components/Modal";
import Button from "../ui-components/Button"
import { useIntl } from "react-intl";

const RevitPopupReminderComponent = ({

  }) => {
  const intl = useIntl();
  const userData = AuthenticationService.getUserData();
  const [showPopup, setShowPopup] = useState(false);
  const [lastRevitPopupReminderClosedDate, setLastRevitPopupReminderClosedDate] = useState(undefined);

  const fetchLastRevitPopupReminderClosedDate = async () => {
    const response = await apiRequest.get(`/users/get_last_revit_popup_reminder_closed_date/${userData.id}`)
    setLastRevitPopupReminderClosedDate(response)
  }

  const updateLastRevitPopupReminderClosedDate = async () => {
    const response = await apiRequest.get(`/users/set_last_revit_popup_reminder_closed_date/${userData.id}`)

    setLastRevitPopupReminderClosedDate(response)
  }

  useEffect(() => {
    if (userData) {
      fetchLastRevitPopupReminderClosedDate()
    }
  }, [userData]);

  useEffect(() => {
    const fetchUser = async () => {
      // const lastRevitPopupReminderClosedDate = localStorage.getItem('lastRevitPopupReminderClosedDate')
      if (userData && !(userData.flg_internal) && !(['resale', 'resale_tintometer'].includes(userData.role_type)) && !(userData?.has_revit_plugin)) {
        if (lastRevitPopupReminderClosedDate === null) {
          setShowPopup(true)
        }else {
          // we check if the last time the user closed the popup is more than 1 week ago
          const lastRevitPopupReminderClosedDateDiff =
            Math.ceil((new Date() - Date.parse(lastRevitPopupReminderClosedDate))
              / (1000 * 60 * 60 * 24))
          if (lastRevitPopupReminderClosedDateDiff >= 14) {
            setShowPopup(true)
          }
        }
      }
    }
    if (userData && lastRevitPopupReminderClosedDate !== undefined) {
      fetchUser();
    }
  }, [userData, lastRevitPopupReminderClosedDate]);

  const closePopup = async () => {
    await updateLastRevitPopupReminderClosedDate()
    setShowPopup(false)
  }

  return (showPopup ?
    <Modal
      onExit={closePopup}
      className={"fixed bottom-0 right-0 mr-2"}
      dialogContentTransitionEnterLeaveProps={{
        enter : "transition ease-out duration-[2000ms] transform",
        enterFrom : "translate-y-full opacity-0",
        enterTo : "translate-y-0 opacity-100",
        leave : "transition ease-in duration-500 transform",
        leaveFrom : "translate-y-0 opacity-100",
        leaveTo : "translate-y-full opacity-0",
      }}
    >
      <div className={"mt-6 items-center"}>
        <p>
          {intl.formatMessage({
            id: "revit_popup_reminder_message",
            defaultMessage: "Ciao! Ricordati che puoi scaricare il plug-in per poter caricare i dati delle tue configurazioni all’interno di un progetto su Autodesk Revit!"
          })}
        </p>
      </div>
      <div className={"flex mt-6 gap-x-4"}>
        <Button
          variant="contained"
          onClick={async ()=> {
            window.open(
              "https://products.kerakoll.com/it-IT/progettazione",
              "_blank");
            await closePopup()
          }
        }
        >
          {intl.formatMessage({
            id: "revit_popup_reminder_download_button",
            defaultMessage: "Scarica il plugin"
          })}
        </Button>
        <Button
        onClick={async () => {
          await closePopup()
        }}>
          {intl.formatMessage({
            id: "revit_popup_reminder_close_button",
            defaultMessage: "Chiudi"
          })}
        </Button>
      </div>
    </Modal>
    : null)

}

export default RevitPopupReminderComponent